function stickyHeader() {
    if ($(window).scrollTop() > 0)
        $('header').addClass('animated-header');
    else
        $('header').removeClass('animated-header');
    
}
$(document).ready(function () {
    stickyHeader();

    $(document).on('mouseenter', '.banner-slide', function () {
        $('.banner-main').addClass('hide');
        $(this).parents('.hero-banner-slide').addClass('active')
    })

    $(document).on('mouseleave', '.banner-slide', function () {
        $('.banner-main').removeClass('hide');
        $(this).parents('.hero-banner-slide').removeClass('active')
    });

    $(document).on('click', '.trigger-mobile-menu', function () {
        $('.main-nav').slideToggle();
    });
}); 

$(window).on('scroll', stickyHeader);

